var exports = {
  "fs": "SpaceBackground.module__starfield___OHNhMm",
  "UB": "SpaceBackground.module__starDrift___OHNhMm",
  "hi": "SpaceBackground.module__spaceBackground___OHNhMm" + " " + "SpaceBackground.module__starfield___OHNhMm",
};

module.exports = exports;
